import { Box, Grid, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import GalleryOfTheirOwn from 'images/ecom/virtual-gallery/GalleryOfTheirOwn.jpg'
import GalleryOfTheirOwnX2 from 'images/ecom/virtual-gallery/GalleryOfTheirOwn-x2.jpg'
import VideoPosterDesktop from 'images/ecom/virtual-gallery/video-poster/poster.jpg'
import VideoPosterMobile from 'images/ecom/virtual-gallery/video-poster/poster-mobile.jpg'
import VideoPosterTablet from 'images/ecom/virtual-gallery/video-poster/poster-tablet.jpg'

export const VideoWrapper = styled('div')(({ theme }) => ({
  height: '310px',
  [theme.breakpoints.up('sm')]: {
    height: '400px',
  },
  [theme.breakpoints.up('xl')]: {
    height: '730px',
  },
}))

export const ImagePlaceholder = withStyles((theme) => ({
  root: {
    backgroundImage: `url("${VideoPosterMobile}")`,
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    zIndex: 0,
    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url("${VideoPosterTablet}")`,
    },
    [theme.breakpoints.up('md')]: {
      backgroundImage: `url("${VideoPosterDesktop}")`,
    },
  },
}))(Box)

export const Video = styled('video')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  zIndex: 1,

  minWidth: '100%',
  minHeight: '100%',
  width: '100%',
  height: '100%',
  transform: 'translate(-50%, -50%)',
  objectFit: 'cover',
})

export const BadgeWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,
  width: '150px',
  [theme.breakpoints.up('sm')]: {
    top: '2%',
    right: '4%',
  },
  [theme.breakpoints.up('md')]: {
    top: '4%',
    left: '15%',
    right: 'auto',
    width: '180px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '202px',
  },
}))

export const GalleryTheirOwnWrapper = styled('div')(({ theme }) => ({
  background: theme.colors.violet[200],
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    background: `linear-gradient(90deg, rgba(237,235,244,1) 50%, ${theme.colors.violet[200]} 50%);`,
    height: 500,
  },
  [theme.breakpoints.up('lg')]: {
    height: 700,
  },
}))

export const GridContainer = styled(Grid)({
  height: '100%',
})

export const ImageWrapper = styled('div')(({ theme }) => ({
  backgroundImage: `url("${GalleryOfTheirOwn}")`,
  width: '100%',
  height: '310px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  [theme.breakpoints.up('sm')]: {
    height: '360px',
  },
  [theme.breakpoints.up('md')]: {
    height: '100%',
  },
  [theme.breakpoints.up('lg')]: {
    backgroundImage: `url("${GalleryOfTheirOwnX2}")`,
  },
}))

export const DescriptionWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '32px 16px 64px',
  maxWidth: '556px',
  margin: '0 auto',
  [theme.breakpoints.up('md')]: {
    padding: '0 16px 0 64px',
    margin: 0,
  },
  [theme.breakpoints.up('lg')]: {
    padding: ' 0 0 0 120px',
  },
}))

export const PriceInfoBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  gap: '8px',
  marginTop: '24px',
  [theme.breakpoints.up('md')]: {
    marginTop: '16px',
    alignItems: 'flex-start',
  },
}))

export const CountdownBox = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '40px',
  marginBottom: '32px',
  [theme.breakpoints.up('md')]: {
    marginTop: 0,
    marginBottom: 0,
    justifyContent: 'flex-start',
  },
}))

export const AboutImageWrapper = styled('div')(() => ({
  display: 'flex',
  marginBottom: '24px',
}))

export const LimitedTextBox = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  marginBottom: '16px',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '16px',
    marginBottom: '12px',
    // The divider is a flex item, so it fills whatever width the text leaves free.
    '&::after': {
      content: '""',
      flex: 1,
      height: '1px',
      marginLeft: '28px',
      backgroundColor: theme.colors.violet[500],
    },
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: '32px',
  },
}))

export const LimitedTimeText = styled(Typography)(({ theme }) => ({
  color: theme.colors.dark,
  fontWeight: 700,
  fontSize: '1rem',
  lineHeight: 1.4,
  [theme.breakpoints.up('md')]: {
    fontSize: '1.125rem',
    lineHeight: 1.2,
  },
}))
